import {
  GET_ACTIVE_PROJECT,
  GET_APPLIED_PROJECT,
  GET_COMPLETE_PROJECT,
  GET_MYOREDR_PROJECT,
  GET_PROJECT,
  GET_PROJECT_BY_ID,
  GET_PROJECT_PROPOSAL_BY_ID,
  GET_UMBERALLY_PROJECT,
} from "../constants";

export const project = (
  state = {
    getprojectlist: [],
    getumbrallyprojectlist: [],
    getprojectbyid: [],
    getprojectappliedlist: [],
    getprojectactivelist: [],
    getprojectcompletelist: [],
    getprojectproposalbyid: [],
    myorderprojectlist: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_PROJECT:
      return { ...state, getprojectlist: action.getprojectlist };
    case GET_UMBERALLY_PROJECT:
      return {
        ...state,
        getumbrallyprojectlist: action.getumbrallyprojectlist,
      };
    case GET_PROJECT_BY_ID:
      return { ...state, getprojectbyid: action.getprojectbyid };
    case GET_APPLIED_PROJECT:
      return { ...state, getprojectappliedlist: action.getprojectappliedlist };
    case GET_ACTIVE_PROJECT:
      return { ...state, getprojectactivelist: action.getprojectactivelist };
    case GET_COMPLETE_PROJECT:
      return {
        ...state,
        getprojectcompletelist: action.getprojectcompletelist,
      };
    case GET_PROJECT_PROPOSAL_BY_ID:
      return {
        ...state,
        getprojectproposalbyid: action.getprojectproposalbyid,
      };
    case GET_MYOREDR_PROJECT:
      return { ...state, myorderprojectlist: action.myorderprojectlist };
    default:
      return state;
  }
};
